import React from 'react';
import ReactModal from 'react-modal';
import 'src/formcontrols/hoc/PopupModal/PopupModal.css';

interface IProps {
  isModalOpen: boolean;
  children?: React.ReactNode;
}

const style = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    bottom: 0,
    left: 0,
    position: 'fixed' as const,
    right: 0,
    top: 0,
    zIndex: 10,
  },
};

class PopupModal extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <div>
        <ReactModal
          ariaHideApp={false}
          isOpen={this.props.isModalOpen}
          className="Modal"
          style={style}
          onAfterOpen={this.disableScroll}
          onAfterClose={this.enableScroll}
          contentLabel="Modal"
        >
          {this.props.children}
        </ReactModal>
      </div>
    );
  }

  private disableScroll = () => {
    // document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  private enableScroll = () => {
    // document.body.style.position = 'static';
    document.body.style.overflow = 'auto';
  };
}

export default PopupModal;
